class AccordionContainer extends SliderComponent {
  constructor() {
    super();

    this.accordions = document.querySelectorAll('.accordion');

    this.init();
  }

  init() {
    this.accordions.forEach( accordion => {
      accordion.addEventListener('click', (event) => {
        this.toggle(event);
      })
    });
  }

  toggle(event) {
    const targetAccordion = event.currentTarget;
    const content = event.currentTarget.querySelector('.accordion__content-inner');

    document.documentElement.style.setProperty('--content-height', `${content.offsetHeight}px`);

    if (targetAccordion.classList.contains('open')) {
      targetAccordion.classList.remove('open')
    } else {
      this.accordions.forEach( accordion => {
        accordion.classList.remove('open')
      })

      targetAccordion.classList.add('open')
    } 
  }  
}

customElements.define('accordion-container', AccordionContainer);